import { getEventIndices, IEventDetail, pimImageToOpenGraphImage } from '@viabizzuno/models';
import { getLayout } from '@viabizzuno/models/server';
import { LayoutDefault } from '@viabizzuno/ui';
import { getPageProps } from '@viabizzuno/ui/server';
import { asEquatable, IStaticContext, PageProps } from '@websolutespa/bom-core';
import { getLabel, getPage, getStaticPathsForSchema } from '@websolutespa/bom-mixer-models/server';
import { LazyLoader, OpenGraph, StructuredData } from '@websolutespa/bom-mixer-ui';
export default function EventDetail({ layout, page, params }: PageProps<IEventDetail>) {
  return (
    <>
      <LazyLoader components={page.components} />
      <StructuredData />
      <OpenGraph item={(metaData) => ({
        ...metaData.openGraph,
        image: page.media ? pimImageToOpenGraphImage(page.media) : undefined,
      })} />
    </>
  );
}

EventDetail.Layout = LayoutDefault;

export async function getStaticProps(context: IStaticContext) {
  const id = asEquatable(context.params.id);
  const market = context.params.market;
  const locale = context.params.locale;
  const layout = await getLayout(market, locale);
  const page = await getPage<IEventDetail>('event_detail', id, market, locale);

  if (!page) {
    return {
      notFound: true,
      revalidate: true,
    };
  }

  const allIndex = await getEventIndices({ market: layout.market, locale: layout.locale, limit: 1 });
  const lblBack = await getLabel('events.back', { market, locale });

  const components = page.components || [];
  page.components = [
    {
      schema: 'block_hero_event',
      id: page.id,
      title: page.title,
      abstract: page.abstract,
      date: page.date,
      categories: page.categories,
      media: page.media,
      href: page.href,
      backlink: {
        href: allIndex[0]?.href || '/',
        title: lblBack?.text || 'back to events',
      },
      add_to_calendar: page.add_to_calendar,
      btn_register: page.btn_register,
    },
    ...components,
  ];

  const props = await getPageProps({ ...context, layout, page });
  return {
    props,
    revalidate: 60 * 60 * 2, // revalidate
  };
}

export async function getStaticPaths() {
  const paths = await getStaticPathsForSchema('event_detail');
  return {
    paths,
    fallback: 'blocking', // runs before initial render
    // fallback: true, // runs in the background
  };
}
